import { createNamespacedHelpers } from 'vuex';

const { mapState, mapMutations } = createNamespacedHelpers('universalDetails');

export default {
  computed: {
    ...mapState(['fieldWithError']),
    editMode() {
      return this.$route.query.editMode === null && !this.isPreview;
    },
    isPreview() {
      return this.$route.query.preview === null;
    },
  },
  methods: {
    ...mapMutations(['setFieldWithError']),
    startPreview() {
      this.$router.replace({ path: this.$route.fullPath, query: { preview: null } });
    },
    endPreview() {
      this.$router.replace({ path: this.$route.fullPath, query: { preview: undefined } });
    },
  },
};
